<div role="group"
     class="td-wb-input-currency-selector__container"
     [formGroup]="parts"
     [attr.aria-labelledby]="formField?.getLabelId()"
     [attr.aria-describedby]="describedbyIds()"
     (focusin)="onFocusIn()"
     (focusout)="onFocusOut($event)">
  <span matTextPrefix>$ &nbsp;</span>
  <div class="td-wb-input-currency-selector__input-container">
    <input class="td-wb-input-currency-selector__input-element"
           type="number"
           [attr.id]="`${id}-input`"
           [attr.aria-labelledby]="formField?.getLabelId()"
           [name]="inputName()"
           [tdWbNumberInput]="numberInputFormat()"
           tdWbNumberInputGroupSeparator="true"
           formControlName="amount"
           (input)="handleInput()"
           #amount/>
    </div>
  <div>
    <mat-select class="td-wb-input-currency-selector__select"
                formControlName="currency"
                (selectionChange)="onCurrencySelectionChange($event.value)"
                (openedChange)="onCurrencySelectOpenedChange($event)"
                #currencySelect>
      <mat-select-trigger class="td-wb-input-currency-selector__trigger">
        <td-wb-icon-flag class="td-wb-input-currency-selector__trigger--flag-icon"
                         aria-hidden="true"
                         [value]="parts.controls.currency?.value"
                         [size]="size()" />
        <span [textContent]="parts.controls.currency?.value"></span>
        <span class="td-wb-input-currency-selector__select-arrow"></span>
      </mat-select-trigger>
       @for (code of codes(); track code) {
        <mat-option class="td-wb-input-currency-selector__currency-option" [value]="code">
          <td-wb-icon-flag class="td-wb-input-currency-selector__flag"
                           aria-hidden="true"
                           [value]="code"
                           [size]="size()" />
          <span [textContent]="code"></span>
        </mat-option>
       }
    </mat-select>
  </div>
</div>
